import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DetailsConfigField } from 'app/entities';
import { AlertService } from 'app/services/alert.service';
import { ProposalService } from '../../pages/proposals/proposals.service';
import { DetailsConfigStorageService } from 'app/services/details-config-storage.service';

@Component({
    selector: 'app-item-details-config-modal',
    templateUrl: './item-details-config-modal.component.html',
    styleUrls: ['./item-details-config-modal.component.scss']
})
export class ItemDetailsConfigModalComponent implements OnInit {
    
    itemDetailsConfig: DetailsConfigField[] = [];
    hideItem: boolean = false;
    
    saving = false;

    constructor(
        public dialogRef: MatDialogRef<ItemDetailsConfigModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private _proposalService: ProposalService,
        private _alertService: AlertService,
        private _detailsConfigStorage: DetailsConfigStorageService
    ) {}

    ngOnInit(): void {
        // Se o item já tem uma configuração, usa ela
        if (this.data.detailsConfig && Array.isArray(this.data.detailsConfig) && this.data.detailsConfig.length > 0) {
            // Normaliza valores para boolean (pode vir string do backend)
            this.itemDetailsConfig = JSON.parse(JSON.stringify(this.data.detailsConfig)).map((field: any) => ({
                ...field,
                value: field.value === true || field.value === 'true' // Garante boolean
            }));
        } else {
            // Item não tem configuração - busca configuração global do usuário
            const globalConfig = this._detailsConfigStorage.getGlobalConfig();
            
            if (globalConfig && globalConfig.length > 0) {
                // Usa as configurações globais definidas pelo usuário
                this.itemDetailsConfig = JSON.parse(JSON.stringify(globalConfig)).map((field: any) => ({
                    ...field,
                    value: field.value === true || field.value === 'true'
                }));
            } else if (this.data.detailsConfigStructure) {
                // Fallback: se não há config global, usa estrutura padrão com tudo true
                this.itemDetailsConfig = JSON.parse(JSON.stringify(this.data.detailsConfigStructure)).map((field: any) => ({
                    ...field,
                    value: true
                }));
            } else {
                this.itemDetailsConfig = [];
            }
        }
        
        // Garante que hide_item existe na config (retrocompatibilidade)
        const hideItemConfig = this.itemDetailsConfig.find(c => c.field === 'hide_item');
        if (!hideItemConfig) {
            this.itemDetailsConfig.unshift({
                field: 'hide_item',
                label: 'Não exibir detalhes deste item',
                value: false
            } as DetailsConfigField);
        }
        
        // Extrai valor de hide_item
        this.hideItem = this.itemDetailsConfig.find(c => c.field === 'hide_item')?.value === true;
    }
    
    onCheckboxChange(event: any, field: string): void {
        this.itemDetailsConfig.map((item) => {
            if (item.field === field) {
                item.value = event.checked;
            }
        });
    }
    
    onHideItemChange(event: any): void {
        this.hideItem = event.checked;
        
        // Atualiza no array de config
        const hideItemField = this.itemDetailsConfig.find(c => c.field === 'hide_item');
        if (hideItemField) {
            hideItemField.value = event.checked;
        }
    }
    
    get displayFieldsDisabled(): boolean {
        return this.hideItem;
    }
    
    get displayFields(): DetailsConfigField[] {
        return this.itemDetailsConfig.filter(c => c.field !== 'hide_item');
    }

    concluir(): void {
        if (!this.data.itemId) {
            this.dialogRef.close(this.itemDetailsConfig);
            return;
        }

        this.dialogRef.close(this.itemDetailsConfig);
    }

    cancel(): void {
        this.dialogRef.close();
    }
}
